<template>
    <div class="modal fade" id="initDocumentModal" tabindex="-1" aria-labelledby="initDocumentModal" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content" v-if="document">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span v-if="document.is_folder == false && document.id == null"><i class="far fa-file"></i> Envoyer
                            document</span>
                        <span v-if="document.is_folder == true && document.id == null"><i class="fas fa-folder"></i> Nouveau
                            dossier</span>
                        <span v-if="document.is_folder == false && document.id != null"><i class="far fa-file"></i>
                            Modification document</span>
                        <span v-if="document.is_folder == true && document.id != null"><i class="fas fa-folder"></i>
                            Modification dossier</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group" v-if="document.is_folder == false && document.id == null">
                        <label for="documentFile" class="required">Document</label>
                        <div class="d-block">
                            <input type="file" v-on:change="onFileChange" id="documentFile" multiple>
                        </div>
                        <span class="ix-text-secondary ix-text-small">Taille fichier maximale : 10 Mo</span>
                        <div class="ix-text-red">{{ errorMessage }}</div>
                    </div>

                    <div class="form-group" v-if="document.is_folder || document.id">
                        <label for="folderName" class="required">Nom</label>
                        <input type="text" class="form-control" v-model="document.name" name="folderName" id="folderName"
                            required>
                    </div>

                    <div class="ix-table-box mb-2" v-if="documents.length > 0">
                        <table class="ix-table ix-table-sm">
                            <thead>
                                <tr>
                                    <th>Nom</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(document, index) in documents" :key="index">
                                    <td><input class="form-control" type="text" v-model="document.name" id="documentName">
                                    </td>
                                    <td class="text-center" @click="documents.splice(index, 1)">
                                        <button class="ix-btn" type="button"> <i class="far fa-trash"></i></button>
                                       
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="form-group" v-if="document.id && document.is_folder">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="1" id="documentPermissions"
                                v-model="keepPermissions">
                            <label class="form-check-label" for="documentPermissions">Appliquer ses droits d'accès à
                                l'ensemble des élements de ce dossier</label>
                        </div>
                    </div>

                    <div class="ix-table-box">
                        <table class="ix-table ix-table-sm">
                            <thead>
                                <tr>
                                    <th>Choisissez les rôles pouvant accéder à
                                        {{ document.is_folder ? 'ce dossier' : 'ces documents' }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(role, index) in roles">
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" :id="'role' + role.id"
                                                value="1" v-model="role.is_checked">
                                            <label class="custom-control-label" :for="'role' + role.id">{{ role.name
                                            }}</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="loadingRoles">
                                    <td>
                                        <i class="far fa-circle-notch fa-spin"></i> Chargement des roles en cours
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="ix-btn green" v-bind:disabled="!checkForm() || loadingForm"
                        @click="postDocument()">
                        <span v-if="!loadingForm"><i class="far fa-check"></i> {{ document.id ? 'Modifier' :
                            (document.is_folder ? "Créer" : "Envoyer") }}</span>
                        <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";

export default {
    name: "DocumentsManagerModal",
    props: {
        admin: Number,
        display: String,
        readonly: String,
        url: String, // Vous devez spécifier le type de la propriété 'url'.
        rolesUrl: String, // Vous devez spécifier le type de la propriété 'rolesUrl'.
        documentableType: String,
        documentableId: Number,
        node: Object,
    },
    watch: {
        documentableId: async function () {
            if (this.documentableId) {
                await this.getData();
            }
        },
    },
    data() {
        return {
            breadcrumbs: [],
            folders: [],
            documents: [],
            roles: [],
            keepPermissions: 1,
            loading: true,
            loadingRoles: false,
            loadingForm: false,
            document: null,
            order: 'name',
            is_admin: this.admin || false,
            errorMessage: null,
        }
    },
    methods: {
        initDocument(isFolder) {
            $('#documentFile').val("");

            this.documents = [];

            this.document = {
                id: null,
                name: null,
                is_folder: isFolder ? 1 : 0,
                file: null,
                files: []
            };

            if (!this.node) {
                this.roles.forEach(role => { role.is_checked = 1; });
            } else {
                this.checkRolesFromDocument(this.node);
            }
        },
        startDocumentModal(isFolder) {
            this.initDocument(isFolder);
            $('#initDocumentModal').modal();
        },
        onFileChange(e) {
            var now = this;
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;

            var arrayFiles = Array.from(files);
            arrayFiles.forEach(function (file, index) {
                var document = {
                    name: null,
                    file: file,
                };

                if (document.name == "" || document.name == null) {
                    document.name = file.name.split('.')[0];
                }

                now.documents.push(document);
            });
        },
        checkForm() {
            if (this.documents.length > 0) {
                return true;
            } else if (this.document) {
                if (this.document.is_folder) {
                    return this.document.name;
                } else {
                    return this.document.id ? this.document.name : this.document.name && this.document.file;
                }
            }
            return false;
        },
        checkAllRoles() {
            this.roles.forEach(role => {
                role.is_checked = 1;
            });
        },
        checkRolesFromDocument(document) {
            var checkedRoles = document.roles.map(role => { return role.id; });
            this.roles.forEach(role => {
                role.is_checked = checkedRoles.includes(role.id) ? 1 : 0;
            });
        },
        async getRoles() {
            this.loadingRoles = true;
            fetch(this.rolesUrl + "?orderBy=!name", {
                method: 'GET',
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loadingRoles = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.roles = data;
                        this.checkAllRoles();
                    });
                }
            }).catch(error => {
                this.loadingRoles = false;
                console.log(error);
            });
        },
        async getData() {
            this.loading = true;

            fetch(this.url + "?orderBy=" + this.order + "&documentable_type=" + this.documentableType + "&documentable_id=" + this.documentableId + "&node=" + (this.nodeId ? this.nodeId : ''), {
                method: 'GET',
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loading = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.folders = data.folders;
                        this.documents = data.documents;
                        this.breadcrumbs = data.breadcrumbs;
                        this.node = data.node;
                    });
                }
            }).catch(error => {
                this.loading = false;
                console.log(error);
            });
        },
        async postDocument() {
            var now = this;
            var end = 0;
            this.loadingForm = true;

            var checkedRoles = this.roles.filter(role => { return role.is_checked; }).map(role => { return role.id; }).join(',');

            if (now.documents.length > 0) {
                now.documents.forEach(function (document, index) {
                    var data = new FormData();
                    data.append('name', document.name);
                    data.append('file', document.file);
                    data.append('documentable_id', now.documentableId);
                    data.append('documentable_type', now.documentableType);
                    data.append('is_folder', document.is_folder ? 1 : 0);
                    data.append('document_id', now.node ? now.node.id : '');
                    data.append('roles', checkedRoles);

                    if (document.id) {
                        data.append('_method', 'PUT');

                        if (document.is_folder) {
                            data.append('keep_permissions', now.keepPermissions ? 1 : 0);
                        }
                    }

                    fetch(now.url + (document.id ? '/' + document.id : ''), {
                        method: "POST",
                        ...now.getHttpJsonRequestHeaders(true),
                        body: data
                    }).then((response) => {
                        now.loadingForm = false;
                        if (response.ok) {
                            now.errorMessage = null;
                            end = end + 1;
                            if (end == now.documents.length) {
                                window.location.reload();
                                now.errorMessage = null;
                            }
                        } else {
                            now.errorMessage = "Impossible de télécharger le fichier.";
                        }
                    }).catch(error => {
                        now.loadingForm = false;
                        console.log(error);
                    });
                });
            } else if (now.document) {
                console.log('test');
                var data = new FormData()
                data.append('name', now.document.name)
                data.append('file', now.document.file)
                data.append('documentable_id', now.documentableId)
                data.append('documentable_type', now.documentableType)
                data.append('is_folder', now.document.is_folder ? 1 : 0)
                data.append('document_id', now.node ? now.node.id : '')
                data.append('roles', checkedRoles)
                if (now.document.id) {
                    data.append('_method', 'PUT')
                    if (now.document.is_folder) {
                        data.append('keep_permissions', now.keepPermissions ? 1 : 0)
                    }
                }
                fetch(now.url + (now.document.id ? '/' + now.document.id : ''), {
                    ...{
                        method: "POST"
                    },
                    ...now.getHttpJsonRequestHeaders(true),
                    ...{
                        body: data
                    }
                }).then((response) => {
                    now.loadingForm = false;
                    if (response.ok) {
                        window.location.reload();
                        now.errorMessage = null;
                    } else {
                        now.errorMessage = "Impossible de télécharger le fichier."
                    }
                }).catch(error => {
                    now.loadingForm = false;
                    console.log(error);
                })
            }
        },
        editDocument(document, index) {
            this.initDocument(document.is_folder);

            this.document.id = document.id;
            this.document.name = document.name;
            this.document.document_id = document.document_id;

            this.checkRolesFromDocument(document);

            $('#initDocumentModal').modal();
        }
    },

    mounted() {
        if (this.display != 'min') {
            this.getRoles();
        }
    }
}


</script>